import { render, staticRenderFns } from "./SupplierDisplayView.vue?vue&type=template&id=5a6edf46"
import script from "./SupplierDisplayView.vue?vue&type=script&lang=js"
export * from "./SupplierDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports